export const confirmationModalOfClusterValueChain = {
    checkBoxLabel: `Don't show this message again`,
    cancel: 'Cancel',
    changeCrossVCMode:
        'We will change the data to reflect the results of IBA analysis conducted across value chains, rather than by each value chain. ' +
        'This mode is effective for comparing technology scores within the same cluster, even if different companies have different value chains but the same technology. ' +
        'The data will be re-displayed due to the different analysis axis. Are you okay with this?\n' +
        '※ If you turn off "Switch to cross-value chain", you can switch the display at any time.',
    filter:
        'Would you like to clear the keyword conditions set for the cluster list? All clusters within the theme will be displayed on the bubble chart.',
    changeClusterIdOfClusterList:
        'If you select a different cluster from the bubble chart, the selected cluster in the list at the bottom of the screen will also change accordingly.',
    searchClusterList: 'Performing a keyword search will deselect the currently selected cluster.',
    changeClusterIdOfLowerTab:
        'If you select a different cluster from the bubble chart, the list at the bottom of the screen will be updated to show the data for the selected cluster.'
}
